import { axios } from '@/utils/request'

/**
 * 库存
 * @param parameter
 * @returns {*}
 */
export function getStorageInventory (parameter) {
  return axios({
    url: '/storage/inventory',
    method: 'get',
    params: parameter
  })
}

/**
 * 保存盘点记录
 * @param parameter
 * @returns {*}
 */
export function savePdResult (parameter) {
  return axios({
    url: '/storage/savepd',
    method: 'post',
    data: parameter
  })
}

/**
 * 获取盘点记录
 * @param parameter
 * @returns {*}
 */
export function getStorageInventoryLogs (parameter) {
  return axios({
    url: '/storage/inventorylogs',
    method: 'get',
    params: parameter
  })
}

/**
 * 删除盘点记录
 * @param parameter
 * @returns {*}
 */
export function deleteStorageInventoryLog (parameter) {
  return axios({
    url: '/storage/inventorylogsdelete',
    method: 'post',
    data: parameter
  })
}

export function getStorageInventoryResult (parameter) {
  return axios({
    url: '/storage/inventoryresult',
    method: 'get',
    params: parameter
  })
}